<template>
<div class="map_bar">
  <slot></slot>
   <div id="container"  class="container"></div>
</div>
</template>

<script>
import { EventBus } from '@/utils/event-bus'
import siteMap from './map'

  export default {
    name:'SiteAddressMap',
    props:{
      addressInfo:{
        type:Object,
        default:()=>({})
      }
    },
    data(){
      return{
      }
    },
    created(){
     EventBus.$on('selectAddress',this.selectAddress)
     siteMap.marker=null
    },
    beforeDestroy(){
       EventBus.$off('selectAddress')
    },
    mounted() {
      const {lon=0,lat=0}=this.addressInfo
      this.map=siteMap.map('container',{lon,lat,})
      this.map.on('click', this.handleClick);// 添加地图点击事件
      siteMap.control(this.map)
      if(lon){
        const positionXY = this.map.getCenter()
        siteMap.addMarker(this.map,{lng:positionXY.lng,lat: positionXY.lat})
      }
  },
  methods:{
   selectAddress(address){
      siteMap.refreshMarker(this.map,{lng:address.lon,lat: address.lat})
    },
    handleClick(e){
       const {lng,lat}=e.lnglat
       siteMap.refreshMarker(this.map,{lng,lat})
       this.$emit('clickMap',{lng,lat})
    }
  }
  }
</script>

<style lang="less" scoped>
.map_bar {
  height:300px;
  padding: 0 40px;
}
.container {
  height: 100%;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  /deep/.amap-logo{
    display: none !important;
  }
  /deep/.amap-copyright {
    display: none !important;
  }
}

</style>